export default __webpack_public_path__ + "static/media/allgemein_50.ee46a7af.jpg";